import Axios from "axios"
// import md5 from 'js-md5'

Axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
Axios.defaults = Object.assign(Axios.defaults, {
  // baseURL: "http://192.168.1.202:8713/",
  // baseURL: ipVar,
  baseURL: "/api",
  timeout: 0,
  //responseType: "application/json",
  withCredentials: true,
})

// 请求拦截器
Axios.interceptors.request.use(
  (config) => {
    // console.log(config)
    /* let datas = config.data
    let timestamp = JSON.stringify(new Date().getTime())
    if(datas){
      datas.timestamp = timestamp;
    }
    let ret = [];
    for (let it in datas) {
      let val = datas[it];
      if (typeof val === 'object' && //
        (!(val instanceof Array) || (val.length > 0 && (typeof val[0] === 'object')))) {
        val = JSON.stringify(val);
        console.log(val)
      }
      ret.push(it + ":"+val);
    }
    // 字典升序
    ret.sort();
    let str = ret.join('&');
    let signstr = md5(str) ;
    let data = datas
    if(data==undefined){

    }
    else {
      delete data['timestamp']
    }*/

    /*console.log(str)*/
    config.headers = {
      //"Content-Type": "application/x-www-form-urlencoded", // 设置很关键
      Accept: "application/json",
    }

    if (config.method != "get") {
      let timeStamp = window.localStorage.getItem("sessionTimeStamp")
      let openid = window.localStorage.getItem("openId")
      let mobile = window.localStorage.getItem("mobile")
      // alert(openid)
      // console.log(openid)
      // let openid = "oeU5Is0iAtegaifFzlefJ62_kwuo"
      if (openid) {
        config.data = {
          openid,
          mobile,
          ...config.data,
        }
      }
    }

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// 响应拦截器
Axios.interceptors.response.use(
  function (response) {
    // console.log(response.data)
    let GoHostUrl = window.location.host
    if (response.data && typeof response?.data === "string") {
      response.data = JSON.parse(response.data)
    }
    if (response.data.status_msg) {
      if (response.data.status_msg == "未登录") {
        // window.location.href='https://h5.xiao-ta.com/login'
      }
      if (response.data.status_msg == "登陆失败") {
        // window.location.href='https://h5.xiao-ta.com/login'
      }
      if (response.data.status_code == 999) {
        // alert('您当前账号访问已达上限，已强制退出，如有疑问请联系小塔客服：010-82702960')
        // window.location.href='https://h5.xiao-ta/login'
        // this.setCookie('', '', -1)
      }
    }
    if (response.status == 403) {
      // window.location.href='https://h5.xiao-ta/login'
    } else {
      return response
    }
  },
  function (error) {
    let GoHostUrl = window.location.host
    console.log(error)
    /*if(error.response.status==403){
      window.location.href='http://'+GoHostUrl+'/login'
      localStorage.clear()
    }*/
    return Promise.reject(error)
  }
)

export default Axios
